import React from 'react';
import HelperMetiers360 from '../../../../services/HelpersMetiers360';
import { useStoreActions } from 'easy-peasy';
import AuthorizationChecker from "../../../../services/AuthorizationChecker";

const VideoFlatComponent = (props) => {
    const { video } = props;
    const {addVideoLength} = useStoreActions(actions => actions.videos);

    const handleMetadata = (e) => {
        if (!video.videoLength && AuthorizationChecker.isAdmin()) {
            const payload = { uniqueId: video.uniqueId, videoLength: e.target.duration };
            addVideoLength(payload);
        }
    };

    const videoSource = HelperMetiers360.readableMediaSource('video', video.videoSource, video.altVideoSource);

    return (
        <video width="100%" controls onLoadedMetadata={handleMetadata}>
            {videoSource && <source src={videoSource} />}
            Votre navigateur ne supporte pas les différents .
        </video>
    )
}

export default VideoFlatComponent;